import * as viewerRoleComponents from '@loomhq/viewer-role-components';
import React from 'react';
import * as redux from 'react-redux';

import * as events from 'constants/events';
import * as flags from 'constants/featureFlag';
import * as analytics from 'utilities/analytics';

import * as hooks from 'hooks/workspace';

import * as scopes from '../../../../shared/constants/scopes';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';
import Scopes from 'components/scopes';

const rbacWrapper = (componentLoader, viewerModifier) => {
  const Component = React.lazy(componentLoader);

  return props => {
    return (
      <FeatureFlaggedComponent
        flag={flags.ROLLOUT_WEBSITE_RECORDING}
        activationValues={[true]}
      >
        <React.Suspense fallback={<div />}>
          <Scopes
            names={[scopes.VIDEO_RECORD_ACCESS]}
            some={false}
            alternate={viewerModifier(Component, props)}
          >
            <Component {...props} />
          </Scopes>
        </React.Suspense>
      </FeatureFlaggedComponent>
    );
  };
};

const Overlay = rbacWrapper(
  () => import('./overlay'),
  () => <div />
);

const ViewerTooltip = viewerRoleComponents.buildCantRecord({
  selectorFn: () => {
    const { showSelectWorkspaceModal, workspaces } = redux.useSelector(
      state => state.workspace
    );

    const { default_workspace_id: defaultWorkspaceId } = redux.useSelector(
      state => state.user.current
    );

    const adminUsers = (hooks.useGetSelectedWorkspaceAdmins() || []).slice(
      0,
      4
    );

    return {
      adminUsers,
      showChangeDefaultMessage: showSelectWorkspaceModal,
      workspaces,
      defaultWorkspaceId,
    };
  },
  hooks: {
    onMouseEnter: () =>
      analytics.track(events.ENGAGED_RBAC_RESTRICTION, {
        scope: scopes.VIDEO_RECORD_ACCESS,
        environment: 'WRU',
      }),
  },
});

const RecordButton = rbacWrapper(
  () => import('./wru-recording-button'),
  (Button, props) => {
    return (
      <ViewerTooltip>
        <Button {...{ ...props, isDisabled: true }} />
      </ViewerTooltip>
    );
  }
);

export { Overlay, RecordButton };
